document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const nav = document.querySelector('[data-mobile-nav]');
      if (!nav) return;
      const isOpen = nav.hasAttribute('hidden') === false;
      if (isOpen) {
        nav.setAttribute('hidden', '');
        button.setAttribute('aria-expanded', 'false');
      } else {
        nav.removeAttribute('hidden');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-image-id]'));
    function showThumb(thumb) {
      if (!main || !thumb) return;
      main.src = thumb.dataset.gallerySrc;
      main.alt = thumb.dataset.galleryAlt || '';
      thumbs.forEach((item) => item.setAttribute('aria-pressed', item === thumb ? 'true' : 'false'));
    }
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showThumb(thumb)));
    gallery.showMedia = (id) => showThumb(thumbs.find((thumb) => thumb.dataset.galleryImageId === String(id)));
    gallery.showColor = (variantTitle, mediaId) => {
      // Recommended Shopify image alt text: "Black - Front", "Black - Back".
      // Show both sides of the chosen color as thumbnails, not other colors.
      const color = String(variantTitle || '').split(' / ')[0].trim().toLowerCase();
      const tagged = thumbs.filter((thumb) => {
        const label = (thumb.dataset.galleryLabel || '').toLowerCase().trim();
        return color && (label === color || label.startsWith(color + ' -') || label.startsWith(color + ' ') || label.startsWith(color + ':'));
      });
      // Never hide images if media isn't consistently labeled.
      const visible = tagged.length ? tagged : thumbs;
      thumbs.forEach((thumb) => { thumb.hidden = !visible.includes(thumb); });
      const preferred = visible.find((thumb) => thumb.dataset.galleryImageId === String(mediaId))
        || visible.find((thumb) => /back|rear/i.test(thumb.dataset.galleryLabel || ''))
        || visible[0];
      showThumb(preferred);
    };
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('[data-variant-select]');
    const idInput = form.querySelector('input[name="id"]');
    const price = form.closest('[data-product-root]')?.querySelector('[data-product-price]');
    const addButton = form.querySelector('[data-add-to-cart]');
    if (!select || !idInput) return;

    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      idInput.value = option.value;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      const available = option.dataset.available === 'true';
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? 'Add to cart' : 'Sold out';
      }
      const gallery = form.closest('[data-product-root]')?.querySelector('[data-product-gallery]');
      if (gallery) gallery.showColor?.(option.dataset.variantTitle, option.dataset.mediaId);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });
    const initial = select.options[select.selectedIndex];
    const gallery = form.closest('[data-product-root]')?.querySelector('[data-product-gallery]');
    if (gallery && initial) gallery.showColor?.(initial.dataset.variantTitle, initial.dataset.mediaId);
  });
});
